import { render } from "./resultadoPublico.vue?vue&type=template&id=4b7ee1ea&scoped=true"
import script from "./resultadoPublico.vue?vue&type=script&lang=js"
export * from "./resultadoPublico.vue?vue&type=script&lang=js"

import "./resultadoPublico.vue?vue&type=style&index=0&id=4b7ee1ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7ee1ea"]])

export default __exports__